/* Noom LP (Kamil 12.09) — countdown to local midnight next to the cart drawer's "today only" heading.
   Markup: snippets/elora-cart-perks.liquid ([data-cart-timer-value]); the drawer re-renders its inner HTML after every
   cart change, so the element is looked up on each tick. No dependency, no DOM write when the text has not changed. */
(function () {
  'use strict';
  if (window.EloraCartTimer) return;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-cart-timer-value]');
    if (!els.length) return;
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    for (var i = 0; i < els.length; i += 1) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }
  tick();
  window.setInterval(tick, 1000);
  window.EloraCartTimer = { tick: tick };
})();
